/**
 * Fit as many menu items as possible in one row; remainder behind "Más...".
 * Matches prototipo_carga_header_v18 renderEcommerceMenuBar.
 */
export function fitEcommerceMenuVisibleCount(
  itemWidths: number[],
  rowWidth: number,
  moreWidth: number,
  maxVisible: number = itemWidths.length,
  gap = 0,
): number {
  const cap = Number.isFinite(maxVisible) ? maxVisible : itemWidths.length;
  let visibleCount = Math.min(itemWidths.length, Math.max(0, cap));
  while (visibleCount > 0) {
    const itemsWidth =
      itemWidths.slice(0, visibleCount).reduce((sum, width) => sum + width, 0) +
      gap * Math.max(0, visibleCount - 1);
    const reserved = visibleCount < itemWidths.length ? moreWidth + gap : 0;
    if (itemsWidth <= rowWidth - reserved) break;
    visibleCount -= 1;
  }
  return visibleCount;
}
